import { patchAddPricingSpecInLenderContextInPricingSpec, PricingRange } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AddPricingSpecInLenderContextForm } from '@/components/modules/AgentDetail/ProvidersDetails/components/AgentPricings/components/PricingSpecsTable/components/AddPricingSpecInLenderContextDialog/components/AddPricingSpecInLenderContextForm';
import {
  AddPricingSpecInLenderContextSchema,
  AddPricingSpecInLenderContextType,
} from '@/components/modules/AgentDetail/ProvidersDetails/components/AgentPricings/components/PricingSpecsTable/components/AddPricingSpecInLenderContextDialog/schemas/AddPricingSpecInLenderContextSchema';
import { getLendersWithoutLenderEarningFees } from '@/components/modules/AgentDetail/ProvidersDetails/components/AgentPricings/components/PricingSpecsTable/components/AddPricingSpecInLenderContextDialog/utils/getLendersWithoutLenderEarningFees';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { ALL_LENDERS } from '@/constants/AllLenders';
import { useRequest } from '@/hooks/requests/useRequest';

interface AddPricingSpecInLenderContextDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  pricingRange: PricingRange;
  refreshData: () => Promise<unknown>;
}

export const AddPricingSpecInLenderContextDialog = ({
  opened,
  setOpened,
  toggleDialog,
  pricingRange,
  refreshData,
}: AddPricingSpecInLenderContextDialogProps) => {
  const { request, loading } = useRequest();

  const onSubmit = async (formValues: AddPricingSpecInLenderContextType) => {
    request(patchAddPricingSpecInLenderContextInPricingSpec, {
      lenderId: formValues.lenderId,
      pricingNameInLenderContext: formValues.pricingNameInLenderContext,
      pricingVersion: formValues.pricingVersion,
      pricingSpecId: pricingRange.id,
    });
    await toggleDialog();
    refreshData();
  };

  const allowedLenders = getLendersWithoutLenderEarningFees(ALL_LENDERS, pricingRange.lenderEarningsFees);

  return (
    <>
      <EditDialogWrapper
        opened={opened}
        setOpened={setOpened}
        handleClose={toggleDialog}
        DialogProps={{
          maxWidth: 'sm',
          fullWidth: true,
        }}
        title={'ADD_PRICING_SPEC_IN_LENDER_CONTEXT'}
        onSubmitForm={onSubmit}
        isLoading={loading}
        formSchema={AddPricingSpecInLenderContextSchema}
      >
        <AddPricingSpecInLenderContextForm lenders={allowedLenders} fieldVariant={FieldVariant.form} fullWidth />
      </EditDialogWrapper>
    </>
  );
};

export interface FormValues {
  lenderId: string;
  pricingNameInLenderContext: string;
  pricingVersion: string;
}
